import * as Yup from 'yup'
export const Schema = Yup.object().shape({
    memberShipFee: Yup.string().required('برای ایجاد صندوق، باید میزان حق‌عضویت پایه‌ی آن را مشخض کنید'),
    date: Yup.string().required('برای ایجاد صندوق، باید سررسید آن را مشخص کنید'),
})

export const getWeeklyOptions: ISelectOption[] = [
    {
        label: 'شنبه‌ها',
        value: '1',
    },
    {
        label: 'یکشنبه‌ها ',
        value: '2',
    },
    {
        label: 'دوشنبه‌ها',
        value: '3',
    },
    {
        label: 'سه‌شنبه‌ها',
        value: '4',
    },
    {
        label: 'چهارشنبه‌ها',
        value: '5',
    },
    {
        label: 'پنجشنبه‌ها',
        value: '6',
    },
    {
        label: 'جمعه‌ها',
        value: '7',
    },
]
export const getMonthlyOptions: () => ISelectOption[] = () => {
    const result: ISelectOption[] = []
    for (let i = 1; i < 31; i++) {
        result.push({ label: `${i} ام هر ماه`, value: `${i}` })
    }

    return result
}
